var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColumn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#EFF0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 8.47V19.53C12.2 19.9701 12.1031 20.0841 12.073 20.1125C12.0313 20.1517 11.8802 20.25 11.389 20.25H8.561C8.06982 20.25 7.91866 20.1517 7.87703 20.1125C7.8469 20.0841 7.75 19.9701 7.75 19.53V8.47C7.75 8.02986 7.8469 7.91586 7.87703 7.88751C7.91866 7.84834 8.06982 7.75 8.561 7.75H11.389C11.8802 7.75 12.0313 7.84834 12.073 7.88751C12.1031 7.91586 12.2 8.02986 12.2 8.47Z",
    stroke: "#282B31",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8.47V19.53C20.25 19.9701 20.1531 20.0841 20.123 20.1125C20.0813 20.1517 19.9302 20.25 19.439 20.25H16.611C16.1198 20.25 15.9687 20.1517 15.927 20.1125C15.8969 20.0841 15.8 19.9701 15.8 19.53V8.47C15.8 8.02986 15.8969 7.91586 15.927 7.88751C15.9687 7.84834 16.1198 7.75 16.611 7.75H19.439C19.9302 7.75 20.0813 7.84834 20.123 7.88751C20.1531 7.91586 20.25 8.02986 20.25 8.47Z",
    stroke: "#282B31",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/column.24f80d14.svg";
export { ForwardRef as ReactComponent };